import { colors } from '../../colors';
var pencilBanner = {
  bgColor: colors.dirtBrown,
  textColor: colors.white,
  textColorDark: colors.metal,
  textColorLight: colors.white
};
export default pencilBanner;